import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from "@material-ui/core";
import React, {Component} from "react";
import PaperBlock from "../../ui/PaperBlock";
import api from "../../api.js"
import { config } from "../../config";
import ImageViewer from "../../ui/ImageViewer";

/**
 * @props item - предмет.
 * @props onCloseButtonClick() - нажатие на кнопку закрытия.
 */

class ItemInfoDialog extends Component {

    constructor(props) {
        super(props)
        this.state={
            images: [],
        }
    }

    async componentDidMount() {
        let response = await api.inventory.image.list(this.props.item.id)
        this.setState({images: response.images})
    }

    render() {

        return <Dialog
            open={true}
            scroll="body"
            fullWidth={true}
        >

            {this.state.dialog}
            
            <DialogTitle>
                Информация о "<span style={{color: "green"}}>{this.props.item.name}"</span>
            </DialogTitle>

            <DialogContent>

                {/* Блок с картинками */}

                <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>
                    <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
                        Фото
                    </Typography>
                    <div
                        style={{
                            marginTop: "10px",
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '10px',
                        }}
                    >

                        { this.state.images.map(
                            (image, n) => {
                                let {id, filename} = image
                                return <div 
                                    key={n}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        aspectRatio: "3/4",
                                        position: "relative",
                                    }}
                                >
                                    <img 
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'cover',
                                            objectPosition: 'center',
                                        }}
                                        src={ `${config.imageApiHost}/image/${filename}?sz=300,300` } 
                                        alt={`Image ${n}`}

                                        onClick = {() => { 
                                            this.setState({
                                                dialog:<ImageViewer
                                                    image={`${config.imageApiHost}/image/${image.filename}`}
                                                    onClick={()=>{
                                                        this.setState({dialog: undefined})
                                                    }}
                                                />
                                            })
                                        }}

                                    />
                                </div>
                            }
                        ) }

                    </div>                
                </PaperBlock>

                <PaperBlock style = {{display: "flex", flexDirection: "column", width: "auto"}}>
                    <Typography variant="subtitle1" style={{ marginBottom: "8px" }}>
                        Комментарий
                    </Typography>                    
                    <Typography variant="body2" style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                        {this.props.item.comment || ''}
                    </Typography>
                </PaperBlock>

            </DialogContent>
            
            <DialogActions>
                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCloseButtonClick === "function") {
							this.props.onCloseButtonClick()
						}
					}}
                >Закрыть</Button>
            </DialogActions>

        </Dialog>

    }
}

export default ItemInfoDialog